import React from 'react';
import styled from 'styled-components';

export const Checkbox = ({ label, labelColor, fontSize, checked, ...rest }) => {
  const handleClick = (event) => {
    event.stopPropagation();
  };

  return (
    <CheckboxContainer onClick={handleClick}>
      <HiddenCheckbox checked={checked} {...rest} />
      <StyledCheckbox checked={checked}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
      {label && (
        <Label labelColor={labelColor} fontSize={fontSize}>
          {label}
        </Label>
      )}
    </CheckboxContainer>
  );
};

// Checkbox must be wrapped by a label
// otherwise onChange event doesn't work on the hidden checkbox
const CheckboxContainer = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-width: 3px;
  width: 14px;
  height: 14px;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: ${({ checked }) => (checked ? '#e6eeff' : '#ddd')};
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px #86bdfd;
  }

  ${Icon} {
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
  }
`;

const Label = styled.span`
  margin-left: 8px;
  font-weight: normal;
  font-size: ${({ fontSize = '13px' }) => fontSize};
  color: ${({ labelColor = '#888', theme }) => theme.colors[labelColor] || labelColor};
`;
